export const PROGRAM_PRODUCT_MATCHING = {
  Academy: 'software_development',
  'Data Science': 'data_science',
  'MS in CSE': 'neovarsity',
  Devops: 'devops',
  'AI/ML': 'ai_ml',
};

export const PROGRAM_MAPPING = {
  'AI & Machine Learning': 'AI/ML',
  'Academy (Software Development)': 'Academy',
};

export const validatorSchema = {
  phone_number: 'mobile',
  name: 'required',
  email: 'email',
  program: 'required',
  position: 'required',
  orgyear: {
    required: true,
    message: 'Add correct graduation year',
    isValid: (value) => {
      const currentTime = new Date();
      const currentYear = currentTime.getFullYear();
      return value <= currentYear + 8 && value >= currentYear - 50;
    },
  },
  otp_verification: {
    required: true,
    message: 'Please fill all the digits',
    isValid: (value) => value.length === 6,
  },
};
